<template>
<div>
  <top-navigation></top-navigation>
  <div>
    <div class="container">
      <div class="row">
        <left-sidebar :showBasket=true :showProductCategoryNavigation=true></left-sidebar>
        <div class="col-sm-9 padding-right content-page">
          <div class="padding-bottom">
              <h2>Thank you</h2>
              <p class="justify" v-if="this.communicationType === 'enquiry'">Thank you for contacting us, your enquiry has been forwarded to our customer services team.</p>
              <p class="justify" v-if="this.communicationType === 'newsletter'">Thank you for signing up for our newsletter.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TopNavigation from '../../components/common/TopNavigation';
import LeftSidebar from '../../components/common/LeftSidebar';

export default {
  name: 'confirm-submission',
  updated() {
    const descEl = document.querySelector('head meta[name="description"]');
    const keywordsEl = document.querySelector('head meta[name="keywords"]');
    const titleMetaEl = document.querySelector('head meta[name="title"]');
    const titleEl = document.querySelector('head title');
    keywordsEl.setAttribute('content', 'books, Biggles books,  Billy Bunter Books, Beano Annuals,  Dandy Annuals,  Rupert Annuals,  Chalet School,  D & M Books,  childrens books, Howard Baker,  PBFA, childrens annuals,  Biggles, Enid Blyton,Giles, Giles Cartoons, storypapers, D. C. Thomson, Elsie Oxenham, Famous Five, Frank Richards, Captain W.E. Johns, school stories, happy hours,Richmal Crompton, childrens annuals, Eagle, Rupert Bear,Fairlie-Bruce, Elinor M. Brent-Dyer, Brent-Dyer, John Leng, PBFA member, The Broons, Oor Wullie, Abbey School Books, Chalet School Books, Broons Annuals,Dandy Monster Comic, Malcolm Saville, Lone Pine, Secret Seven, comic books');
    titleMetaEl.setAttribute('content', 'D&M Books specialise in buying and selling old and rare childrens books, annuals and comics.');
    descEl.setAttribute('content', 'D&M Books specialise in buying and selling old and rare childrens books, annuals and comics.');
    titleEl.textContent = 'D&M Books specialise in buying and selling old and rare childrens books, annuals and comics.';
  },
  computed: {
    communicationType() {
      return this.$route.params.communicationType;
    },
  },
  components: {
    'top-navigation': TopNavigation,
    'left-sidebar': LeftSidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/content/ThankYou.vue